export var wrapAnalyserNodeGetFloatTimeDomainDataMethod = function wrapAnalyserNodeGetFloatTimeDomainDataMethod(nativeAnalyserNode) {
  nativeAnalyserNode.getFloatTimeDomainData = function (array) {
    var byteTimeDomainData = new Uint8Array(array.length);
    nativeAnalyserNode.getByteTimeDomainData(byteTimeDomainData);
    var length = Math.max(byteTimeDomainData.length, nativeAnalyserNode.fftSize);

    for (var i = 0; i < length; i += 1) {
      array[i] = (byteTimeDomainData[i] - 128) * 0.0078125;
    }

    return array;
  };
};